/*
Defines the custom element <ravel-visualizer-1>
*/

import { RavelVisualizer1 } from './src/RavelVisualizer1.js';


customElements.define('ravel-visualizer-1', RavelVisualizer1);
